import { render } from "./ContactoPanel.vue?vue&type=template&id=5718b9d5"
import script from "./ContactoPanel.vue?vue&type=script&lang=js"
export * from "./ContactoPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__